import(/* webpackMode: "eager", webpackExports: ["Pagination"] */ "/app/app/(reporter)/reporter/components/Pagination.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SuggestionGallery"] */ "/app/app/(tourism)/tourism/components/SuggestionGallery.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["UniversalFilterTabs"] */ "/app/app/components/shared/UniversalFilterTabs.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["UniversalUpload"] */ "/app/app/components/shared/UniversalUpload.tsx");
